import { unformat } from '@react-input/number-format';

export const toNumber = (v: number | string) => {
    if (typeof v === 'number') {
        return v;
    }

    if (typeof v !== 'string') {
        return 0;
    }

    const locale = (typeof window !== 'undefined' && window.navigator?.language) || 'en-US';
    return Number(unformat(v, locale));
};
